const styles = {
  explanation: { color: 'neutral.main', mb: 4 },
  resendCode: { mt: 2, mb: 3 },
  alert: { mt: 2, mb: 2.75 },
  submitButton: { mt: 2 },
  circularProgress: { color: 'neutral.white' },
}

export default styles
